import makeUseStyles from "@/core/ui/style/util/makeUseStyles"
import UserAvatar from "@/user/common/avatar/UserAvatar"
import { MentionSuggestionItemProps } from "@components/chat/channel/trigger/hooks/useMentionTrigger"
import { DiscoIcon, DiscoText } from "@disco-ui"
import DiscoDropdownItem from "@disco-ui/dropdown/DiscoDropdownItem"

function MentionSuggestionItem(props: MentionSuggestionItemProps) {
  const { entity, selected } = props
  const classes = useStyles()

  if (entity.type === "user") {
    return (
      <DiscoDropdownItem
        selected={selected}
        icon={
          <UserAvatar
            user={{
              id: entity.disco_user_id,
              first_name: entity.first_name,
              last_name: entity.last_name,
              avatar: entity.avatar,
              name: entity.name,
              is_test_user: entity.is_disco_test_user || false,
            }}
            size={32}
            testid={"MentionUserAvatar"}
          />
        }
        testid={`MentionSuggestionItem.${entity.first_name} ${entity.last_name}`}
        iconSize={32}
        className={classes.suggestionItem}
        title={<DiscoText variant={"body-md-600"}>{entity.name}</DiscoText>}
        component={"div"}
      />
    )
  }

  if (entity.name === "channel") {
    return (
      <DiscoDropdownItem
        selected={selected}
        icon={<DiscoIcon icon={"sound-max"} width={32} height={32} />}
        className={classes.suggestionItem}
        classes={{
          icon: classes.icon,
        }}
        title={
          <>
            <DiscoText
              variant={"body-md-600"}
              display={"inline"}
            >{`@${entity.name}`}</DiscoText>{" "}
            <DiscoText display={"inline"}>{"Notify everyone in the channel"}</DiscoText>
          </>
        }
        iconSize={32}
        testid={"MentionSuggestionItem.at-channel"}
        component={"div"}
        tooltip={entity.disabled && entity.disabledReason}
        disabled={entity.disabled}
      />
    )
  }

  // Unknown suggestion
  return null
}

const useStyles = makeUseStyles((theme) => ({
  suggestionItem: {
    padding: theme.spacing(1.5),
  },
  icon: {
    width: 32,
    height: 32,
  },
}))

export default MentionSuggestionItem
